import React, {useState} from 'react';
import '../Styles/Custom.css';
import { FaArrowRightLong } from "react-icons/fa6";

import { Link } from 'react-router-dom';







export default function Customizations ()  {
   
 const [toContact, setToContact] = useState('contact');

    
  return (

      
    <div className='container-fluid text-center'>
       
      <div className='custom-heading text-cenetr'>
      <div className='custom'>Custom Pieces</div>
        How it works
      </div>
      <div className='how-it-works'>
      
        <ul className="list-group list-group-flush">
            <li className="list-group-item">
                <div className='mb-1 list-heading'>
                    First Draft
                </div>
                With the deatails you provide, we start sketching design concepts until we find what feels right.
            </li>
            <li className="list-group-item">
            <div className='mb-1 list-heading'>
                    Examples
                </div>
                If you are unsure, we can make suggestions and show examples of what can be done. We can make any changes from here before the finished product is sent out.
                </li>
            <li className="list-group-item">
                <div className='mb-1 list-heading'>
                    Finished product
                </div>
                Once you approve the final design, your custom work will be completed and shipped right to your door for you to enjoy.
               </li>
               <li className='list-group-item'>

                <div className='custom-btn'>
                
              <Link to='/Contact'>
               <button type='button' className='btn custom-btn' onClick={() => setToContact('contact') }>
                
                Ready to Design? <FaArrowRightLong />
                </button>
                {toContact === "contact" ? <hr/> : <></>}
                </Link>
                
               </div>

               </li>
        </ul>
      </div>
    </div>
  )
}



